import React, { useState, useEffect, useRef } from 'react';
import party from 'party-js';
import { useAlgo } from '../hooks/useAlgo';
import Button from './Button';
import Spinner from './Spinner';

function OptInButton({ children, assetId }) {
  const confettiRef = useRef();
  const { optIn } = useAlgo();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const onOptIn = async () => {
    try {
      setLoading(true);
      await optIn(assetId);
      party.confetti(confettiRef.current, {
        count: party.variation.range(20, 60),
      });
      party.confetti(confettiRef.current, {
        count: party.variation.range(20, 60),
      });
      party.confetti(confettiRef.current, {
        count: party.variation.range(20, 60),
      });
      setSuccess(true);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button disabled={loading} onClick={onOptIn}>
        {loading ? <Spinner dimensionClasses='w-6 h-6' /> : success ? 'Successfully opted-in! 🥳' : children}
      </Button>
      <div ref={confettiRef}></div>
    </>
  );
}

export default OptInButton;
